import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec97901c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal","display":"block","padding-top":"0.25rem"} }, "条件组关系", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal"} }, "条件组表达式", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-desc" }, "使用表达式构建复杂逻辑，例如: (A & B) | C", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal"} }, "表单设备字段", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-desc" }, "使用设备相关的条件需要配置表单设备字段", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal"} }, "表单组织字段", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-desc" }, "使用组织相关的条件需要配置表单组织字段", -1))
const _hoisted_8 = { style: {"margin":"0 15px 15px 0"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 添加条件组 ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-desc pl-2" }, "只有必填选项才能作为审批条件", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_ellipsis = _resolveComponent("app-ellipsis")!
  const _component_vue_draggable_next = _resolveComponent("vue-draggable-next")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_group_item = _resolveComponent("group-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      inline: "",
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "调整优先级",
          prop: "level"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_popover, {
              placement: "right",
              title: "拖拽条件调整优先级顺序",
              width: 270,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "Sort",
                  size: "default"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("第" + _toDisplayString(_ctx.nowNodeLeave + 1) + "级", 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_vue_draggable_next, {
                  style: {"width":"100%","min-height":"25px"},
                  list: _ctx.prioritySortList,
                  group: "from",
                  options: _ctx.sortOption
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prioritySortList, (cd, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass({ 'drag-no-choose': true, 'drag-hover': cd.id === _ctx.selectedNode.id }),
                        key: index
                      }, [
                        _createVNode(_component_app_ellipsis, {
                          style: {"width":"160px"},
                          "hover-tip": "",
                          content: cd.name
                        }, null, 8, ["content"]),
                        _createElementVNode("div", null, "优先级 " + _toDisplayString(index + 1), 1)
                      ], 2))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["list", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { "label-width": "150px" }, {
          label: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.config.groupsType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.groupsType) = $event)),
              "active-color": "#409EFF",
              "inactive-color": "#c1c1c1",
              "active-value": "AND",
              "inactive-value": "OR",
              "active-text": "且",
              "inactive-text": "或"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              size: "default",
              modelValue: _ctx.config.expression,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.expression) = $event)),
              placeholder: "输入条件组关系表达式  &为与，|为或"
            }, null, 8, ["modelValue"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              size: "default",
              style: {"width":"100%"},
              modelValue: _ctx.config.formProject,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.formProject) = $event)),
              placeholder: "选择表单中的设备字段",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formRequiredList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: i,
                    label: item.title,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              size: "default",
              style: {"width":"100%"},
              modelValue: _ctx.config.formOrgCode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.formOrgCode) = $event)),
              placeholder: "选择表单中的组织字段",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formRequiredList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: i,
                    label: item.title,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        icon: "Plus",
        round: "",
        onClick: _ctx.addConditionGroup
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_10
    ]),
    _createVNode(_component_group_item, { ref: "group_item" }, null, 512)
  ]))
}